var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m480-261.54-158.769 68.154q-36.153 15.461-68.691-5.924-32.539-21.384-32.539-60.153v-488.228q0-30.308 21-51.308t51.308-21h375.382q30.308 0 51.308 21t21 51.308v488.228q0 38.769-32.539 60.153-32.538 21.385-68.691 5.924L480-261.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsave);
export default __webpack_public_path__ + "static/media/unsave.2e8f20e4b62a7fc7a6e5329ff232228c.svg";
export { ForwardRef as ReactComponent };